import React, {useLayoutEffect, useRef, useState} from 'react';
import {Box, Button, IconButton, Typography} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const STORAGE_KEY = 'cookieNoticeDismissed';
export default function CookieNotice() {
    const [open, setOpen] = useState(() => localStorage.getItem(STORAGE_KEY) !== '1');
    const banner = useRef(null);
    useLayoutEffect(() => {
        if (!open) return;
        const previous = document.body.style.paddingBottom;
        const measure = () => {document.body.style.paddingBottom = `${banner.current?.getBoundingClientRect().height || 0}px`;};
        measure();
        const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
        if (banner.current) observer?.observe(banner.current);
        window.addEventListener('resize', measure);
        return () => {observer?.disconnect(); window.removeEventListener('resize', measure); document.body.style.paddingBottom = previous;};
    }, [open]);
    if (!open) return <IconButton aria-label="Informații despre cookie-uri" onClick={() => setOpen(true)} sx={{position: 'fixed', bottom: 16, right: 16, zIndex: 2000, bgcolor: '#1f2937', color: '#f3f4f6', '&:hover': {bgcolor: '#374151'}}}><HelpOutlineIcon /></IconButton>;
    return <Box ref={banner} role="region" aria-label="Informații despre cookie-uri" sx={{position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2000, bgcolor: '#1f2937', color: '#f3f4f6', px: 2.5, py: 1.75, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1.5}}>
        <Typography variant="body2" sx={{flex: '1 1 240px'}}>Acest site nu folosește cookie-uri de tracking sau analytics. Autentificarea folosește stocarea locală a browserului pentru a păstra sesiunea.</Typography>
        <Button variant="outlined" sx={{color: 'inherit', borderColor: 'currentColor'}} onClick={() => {localStorage.setItem(STORAGE_KEY, '1'); setOpen(false);}}>Am înțeles</Button>
    </Box>;
}
